import { ROUTES } from '@/shared/config'
import { navigateToFx } from '@/shared/lib/providers'
import {
  DislikeOutlined,
  FolderAddOutlined,
  HeartOutlined,
  LikeOutlined,
  SearchOutlined,
  ShareAltOutlined,
  StopOutlined,
  VerticalLeftOutlined,
} from '@ant-design/icons'
import { type TableProps, Typography } from 'antd'
import { useUnit } from 'effector-react'

import { type GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem } from '../../api'
import { getAuthorsStatisticsSortOrderByField } from '../../lib/types/authors'
import { $sorterResult } from '../../model/statistics-authors-data.model'

export const useAuthorsStatisticsTableColumns =
  (): TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['columns'] => {
    const sorterResult = useUnit($sorterResult)

    const columns: TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['columns'] =
      [
        {
          title: 'Автор',
          width: 150,
          dataIndex: 'nickname',
          key: 'nickname',
          sorter: true,
          sortOrder: getAuthorsStatisticsSortOrderByField(
            sorterResult,
            'nickname',
          ),
          render: (_, author) => {
            const route = ROUTES.AUTHORS.EDIT.replace(':id', author.id)
            return (
              <span key={author.id}>
                <Typography.Link
                  onClick={() => void navigateToFx({ to: route })}
                >
                  {author.nickname}
                </Typography.Link>
              </span>
            )
          },
        },
        {
          title: <HeartOutlined title="Нравится" />,
          width: 100,
          ellipsis: true,
          dataIndex: 'likesCount',
          key: 'likesCount',
          sorter: true,
          sortOrder: getAuthorsStatisticsSortOrderByField(
            sorterResult,
            'likesCount',
          ),
        },
        {
          title: <StopOutlined title="Не нравится" />,
          width: 100,
          ellipsis: true,
          dataIndex: 'dislikesCount',
          key: 'dislikesCount',
          sorter: true,
          sortOrder: getAuthorsStatisticsSortOrderByField(
            sorterResult,
            'dislikesCount',
          ),
        },
        {
          title: 'Треки',
          children: [
            {
              title: <LikeOutlined title="Нравится" />,
              width: 100,
              ellipsis: true,
              dataIndex: 'tracksLikesCount',
              key: 'tracksLikesCount',
              sorter: true,
              sortOrder: getAuthorsStatisticsSortOrderByField(
                sorterResult,
                'tracksLikesCount',
              ),
            },
            {
              title: <DislikeOutlined title="Не нравится" />,
              width: 100,
              ellipsis: true,
              dataIndex: 'tracksDislikesCount',
              key: 'tracksDislikesCount',
              sorter: true,
              sortOrder: getAuthorsStatisticsSortOrderByField(
                sorterResult,
                'tracksDislikesCount',
              ),
            },
            {
              title: <ShareAltOutlined title="Поделились" />,
              width: 100,
              ellipsis: true,
              dataIndex: 'tracksSharesCount',
              key: 'tracksSharesCount',
              sorter: true,
              sortOrder: getAuthorsStatisticsSortOrderByField(
                sorterResult,
                'tracksSharesCount',
              ),
            },
            {
              title: <FolderAddOutlined title="Добавлений в плейлист" />,
              width: 100,
              ellipsis: true,
              dataIndex: 'tracksPlaylistsCount',
              key: 'tracksPlaylistsCount',
              sorter: true,
              sortOrder: getAuthorsStatisticsSortOrderByField(
                sorterResult,
                'tracksPlaylistsCount',
              ),
            },
            {
              title: 'Прослушиваний',
              children: [
                {
                  title: <span title="Более 50% трека">{'>50%'}</span>,
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksListens50Count',
                  key: 'tracksListens50Count',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksListens50Count',
                  ),
                },
                {
                  title: <span title="Более 75% трека">{'>75%'}</span>,
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksListens75Count',
                  key: 'tracksListens75Count',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksListens75Count',
                  ),
                },
                {
                  title: <span title="Более 95% трека">{'>95%'}</span>,
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksListens95Count',
                  key: 'tracksListens95Count',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksListens95Count',
                  ),
                },
                {
                  title: 'Всего',
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksListensCount',
                  key: 'tracksListensCount',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksListensCount',
                  ),
                },
                {
                  title: <SearchOutlined title="Запусков из поиска" />,
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksSearchCount',
                  key: 'tracksSearchCount',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksSearchCount',
                  ),
                },
                {
                  title: <VerticalLeftOutlined title="Пропусков" />,
                  width: 100,
                  ellipsis: true,
                  dataIndex: 'tracksSwapsCount',
                  key: 'tracksSwapsCount',
                  sorter: true,
                  sortOrder: getAuthorsStatisticsSortOrderByField(
                    sorterResult,
                    'tracksSwapsCount',
                  ),
                },
              ],
            },
          ],
        },
      ]

    return columns
  }
